import { UseMutationResult } from "@tanstack/react-query";
import useAccessibilityModalStore, { IAccessibilityModalState } from "../store";

export class Handlers {
  private accessibilityModalState: IAccessibilityModalState;

  constructor() {
    this.accessibilityModalState = useAccessibilityModalStore.getState();
  }

  handleSave = (
    createHook: UseMutationResult<unknown, Error, void, unknown>,
    updateHook: UseMutationResult<unknown, Error, void, unknown>
  ) => {
    if (
      this.accessibilityModalState.isDefault ||
      this.accessibilityModalState.isGlobal
    ) {
      createHook.mutate();
    } else {
      updateHook.mutate();
    }
  };
}
